import axios from 'axios';
import { DASHBOARD } from './types';
import { setAlert } from './alert';
import { changeLoader } from './loader';

export const obtenerDashboard = (filtros = {}) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(filtros);
    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/dashboard`, body, config);
        dispatch({ type: DASHBOARD.OBTENER, payload: res.data });
    } catch (error) {
        if (error?.response?.data?.msg) {
            dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};
